import * as React from 'react';

function SvgLaybuyColour(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 56 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.852 12.766c0-.1.079-.18.176-.18.097 0 .176.08.176.18v4.376h2.645c.09 0 .163.074.163.166a.164.164 0 01-.162.167h-2.822a.181.181 0 01-.176-.18v-4.529zM28.583 15.783l-1.249-2.81-1.249 2.81h2.498zm-3.504 1.45l2.023-4.492a.248.248 0 01.236-.172h.014a.248.248 0 01.237.172l2.015 4.483c.017.033.027.07.027.107a.169.169 0 01-.168.166.21.21 0 01-.176-.138l-.555-1.25h-2.794l-.554 1.257a.18.18 0 01-.169.131.16.16 0 01-.162-.152c0-.039.01-.077.026-.111zM31.857 15.549L30.01 12.88a.234.234 0 01-.034-.106c.005-.1.085-.18.183-.18.069.002.131.043.162.106l1.718 2.533 1.725-2.533c.03-.06.09-.101.156-.107a.185.185 0 01.176.174.272.272 0 01-.054.139l-1.833 2.635v1.776c0 .1-.079.18-.176.18a.178.178 0 01-.176-.18v-1.768zM37.615 16.534c.46 0 .737-.167.737-.528v-.014c0-.325-.238-.527-.771-.527h-1.207v1.068h1.24zm-.278-1.957c.46 0 .751-.152.751-.513v-.014c0-.32-.243-.5-.684-.5h-1.028v1.027h.96zm-1.977-1.429c0-.294.233-.534.52-.534h1.678c.54 0 .967.153 1.238.427.215.217.333.517.325.826v.014c0 .549-.285.854-.625 1.049.549.213.887.54.887 1.193v.014c0 .887-.704 1.331-1.77 1.331h-1.732a.527.527 0 01-.52-.533l-.001-3.787zM40.508 15.388v-2.281c0-.295.233-.534.52-.534.287 0 .52.239.52.534v2.255c0 .79.386 1.2 1.022 1.2s1.022-.396 1.022-1.165v-2.29c0-.295.233-.534.52-.534.288 0 .52.239.52.534v2.247c0 1.471-.805 2.193-2.08 2.193-1.276 0-2.044-.73-2.044-2.159zM47.271 15.597l-1.524-2.13a.643.643 0 01-.13-.382.515.515 0 01.521-.513c.236 0 .386.131.514.327l1.15 1.7 1.17-1.714c.13-.195.285-.32.501-.32a.488.488 0 01.508.52.675.675 0 01-.135.375l-1.529 2.116v1.402a.527.527 0 01-.52.533.527.527 0 01-.52-.533l-.006-1.381z"
        fill="currentColor"
      />
      <mask
        id="LaybuyColour_svg__a"
        maskUnits="userSpaceOnUse"
        x={5}
        y={9}
        width={14}
        height={11}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.913 9.04H18.04v10.082H5.913V9.04z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#LaybuyColour_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.056 9.946l-1.094 1.122c-.076.078-.185 0-.185 0l-1.399-1.463a1.14 1.14 0 00-1.636 0 1.21 1.21 0 000 1.678l2.318 2.384a1.139 1.139 0 001.636 0l1.945-1.994.34-.359a.586.586 0 01.845 0 .6.6 0 01-.004.848l-.351.362-3.53 3.624a.143.143 0 01-.206.007l-.007-.007-3.842-3.94a1.14 1.14 0 00-1.636 0 1.212 1.212 0 000 1.678l4.79 4.913-.026-.023a1.14 1.14 0 001.637 0l4.46-4.574.046-.048a3.03 3.03 0 00.067-4.208 2.85 2.85 0 00-4.168 0z"
          fill="#786DFF"
        />
      </g>
    </svg>
  );
}

export default SvgLaybuyColour;
